import LotteryDetails from "./LotteryDetails";
export default LotteryDetails;
